import MS_CONST from './msconst.js'
import MS_CACHE from './mscache.js'
import MS_AXIOS from './msaxios.js'

//-----------------------------------------------------------------------
//-----------------------------------------------------------------------
class msCore {
    constructor() {
        this.contentCache    = MS_CACHE.msCacheContent;
        this.loginCache      = MS_CACHE.msCacheLogin;
        this.settingsCache   = MS_CACHE.msCacheSettings;
        this.webbookCache    = MS_CACHE.msCacheWebbook;
        this.advertiseCache  = MS_CACHE.msCacheAdvertise;
        this.msaxios         = MS_AXIOS.msAxios;
        this.loggedIn        = false;
        this.inProgress      = false;
    }    
    //-----------------------------------------------------------------------
    hasElements(array) {
        for (var key in array) {
            return true;
        }        
        return false;
    }
    //-----------------------------------------------------------------------
    countElements(array) {
        var cnt = 0;
        for (var key in array) {
            cnt++;
        }        
        return cnt;
    }
    //-----------------------------------------------------------------------
    urlB64ToUint8Array(base64String) {
        let padding = '='.repeat((4 - base64String.length % 4) % 4);
        let base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');

        let rawData = window.atob(base64);
        let outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }        
    //-----------------------------------------------------------------------
    isOnline() {
        return navigator.onLine;
    } 
    //-----------------------------------------------------------------------
    isLoggedIn() {
        return this.loggedIn;
    }
    //-----------------------------------------------------------------------
    isFirstVisit(callback) {
        this.loadCacheSettings(function(data) {
            if (data[MS_CONST.SETTING_VISITED])
                callback(false);
            else
                callback(true);
        });
    }
    //-----------------------------------------------------------------------
    isInProgress() {
        return this.inProgress;
    }
    //-----------------------------------------------------------------------
    showError(context, message) {
        let link = context.$router.currentRoute.path;
        context.$router.push({name: 'Errorpage', params: { message: message, backlink: link }});
    }
    //-----------------------------------------------------------------------
    loadCacheAdvertise(callback) {
        return this.advertiseCache.loadCache(callback);
    }
    //-----------------------------------------------------------------------
    loadCacheContent(callback) {
        return this.contentCache.loadCache(callback);
    }
    //-----------------------------------------------------------------------
    loadCacheContentList(topId, subId, callback) {
        var listId = topId;
        if (subId)
            listId += '-' + subId;
        this.loadCacheContent(function(data) {
            if (!data || !data[listId])
                callback(false);

            callback(data[listId]);
        });
    }
    //-----------------------------------------------------------------------
    loadCacheContentPost(listId, postId, callback) {
        this.loadCacheContent(function(data) {
            if (!data || !data[listId] || !data[listId]['p' + postId]) {
                callback(false);
            }
            else {
                callback(data[listId]['p' + postId]);
            }
        });
    }
    //-----------------------------------------------------------------------
    loadCacheLogin(callback) {
        return this.loginCache.loadCache(callback);
    }
    //-----------------------------------------------------------------------
    loadCacheSettings(callback) {
        return this.settingsCache.loadCache(callback);
    }
    //-----------------------------------------------------------------------
    loadCacheWebbook(callback) {
        return this.webbookCache.loadCache(callback);
    }
    //-----------------------------------------------------------------------
    saveCacheAdvertise(responseData) {
        return this.advertiseCache.saveCache(responseData);
    }
    //-----------------------------------------------------------------------
    saveCacheContent(responseData) {
        return this.contentCache.saveCache(responseData);
    }
    //-----------------------------------------------------------------------
    saveCacheContentList(topId, subId, responseData) {
        var self = this;
        var listId = topId;
        if (subId)
            listId += '-' + subId;
        this.loadCacheContent(function(data) {
            let cache = {};
            if (data)
                cache = data;
            
            if (!cache)
                cache = {};

            cache[listId] = responseData;
            self.contentCache.saveCache(cache);
        });
    }
    //-----------------------------------------------------------------------
    saveCacheContentPost(listId, postId, responseData) {
        var self = this;
        this.loadCacheContent(function(data) {
            let cache = {};
            if (data)
                cache = data;
            
            if (!cache[listId])
                cache[listId] = {};

            cache[listId]['p' + postId] = responseData;
            self.contentCache.saveCache(cache);
        });
    }
    //-----------------------------------------------------------------------
    saveCacheLogin(responseData, callback) {
        return this.loginCache.saveCache(responseData, callback);
    }    
    //-----------------------------------------------------------------------
    saveCacheSetting(setting) {
        var self = this;
        var key  = Object.keys(setting)[0];
        var value = setting[key];

        this.settingsCache.loadCache(function (data) {
            let cache = {};
            if (data)
                cache = data;
            
            cache[key] = value;
            self.settingsCache.saveCache(cache);
        });        
    }
    //-----------------------------------------------------------------------
    saveCacheWebbook(responseData, callback) {
        return this.webbookCache.saveCache(responseData, callback);
    }
    //-----------------------------------------------------------------------
    deleteCacheContent() {
        return this.contentCache.deleteCache();
    }
    //-----------------------------------------------------------------------
    deleteCacheAll() {
        this.contentCache.deleteCache();
        this.loginCache.deleteCache();
        this.settingsCache.deleteCache();
        this.webbookCache.deleteCache();
        this.advertiseCache.deleteCache();
        return true;
    }
    //-----------------------------------------------------------------------
    apiAdvertising(context, callback) {
        context.$log.debug('begin');
        var self = this;
        var errormessage = '';
        this.msaxios.setContext(context);
        let params = {};
        this.msaxios.getData('get_advertising', params, function (err, response) {
            if (!err) {
                let rc = response.data.rc;
                if (rc=="ok") {
                    let advertising = response.data.advertising;
                    context.$log.info('Advertising-Data empfangen. Anzahl Datenzeilen: '+ self.countElements(advertising));
                    callback(false, advertising);
                }
                else {
                    context.$log.error('msAxios apiAdvertising Error 1');
                    errormessage = response.data.message;
                }
            }
            else {
                context.$log.error('msAxios apiAdvertising Error 2');
                errormessage = response;
            }
            if (errormessage.length) {
                context.$log.error('msAxios apiAdvertising Error: ' + errormessage);
                callback(true, errormessage);
            }
        });

    }
    //-----------------------------------------------------------------------
    apiPostlist(context, token, listId, sublistId, callback) {        
        var self = this;
        var errormessage = '';
        this.msaxios.setContext(context);
        let params = { token: token, list_id: listId };
        if (sublistId)
            params = { token: token, list_id: listId, sublist_id: sublistId };
        this.msaxios.getData('get_postlist', params, function (err, response) {
            if (!err) {
                let rc = response.data.rc;
                if (rc=="ok") {
                    let postlist = response.data.postlist;
                    context.$log.info('Postlist empfangen. Anzahl Listeneinträge: '+ self.countElements(postlist));
                    callback(false, postlist);
                }
                else {
                    errormessage = response.data.message;
                }
            }
            else {
                errormessage = response;
            }
            if (errormessage.length) {
                context.$log.error('apiPostlist msAxios Error: ' + errormessage);
                callback(true, errormessage);
            }
        });
    }
    //-----------------------------------------------------------------------
    apiPost(context, token, listId, postId, callback) {      
        context.$log.debug('begin');
        var self = this;
        var errormessage = '';
        this.msaxios.setContext(context);
        let params = { token: token, post_id: postId };
        if (listId)
            params = { token: token, list_id: listId, post_id: postId };
        this.msaxios.getData('get_post', params, function (err, response) {
            if (!err) {
                let rc = response.data.rc;
                if (rc=="ok") {
                    let post = response.data.post;
                    context.$log.info('Post empfangen. ID:', post.id);
                    callback(false, post);
                }
                else {
                    errormessage = response.data.message;
                }
            }
            else {
                errormessage = response;
            }
            if (errormessage.length) {
                context.$log.error('apiPost msAxios Error: ' + errormessage);
                callback(true, errormessage);
            }
        });
    }
    //-----------------------------------------------------------------------
    apiWebbook(context, callback) {
        context.$log.debug('begin');
        var self = this;
        var errormessage = '';
        this.msaxios.setContext(context);
        let params = {};
        this.msaxios.getData('get_webbook', params, function (err, response) {
            if (!err) {
                let rc = response.data.rc;
                if (rc=="ok") {
                    let webbook = response.data.webbook;
                    context.$log.info('Webbook-Texte empfangen.');
                    callback(false, webbook);
                }
                else {
                    errormessage = response.data.message;
                }
            }
            else {
                errormessage = response;
            }
            if (errormessage.length) {
                context.$log.error('apiWebbook msAxios Error: ' + errormessage);
                callback(true, errormessage);
            }
        });
    }
    //-----------------------------------------------------------------------
    apiMessages(context, token, callback) {
        context.$log.debug('begin');
        var self = this;
        var errormessage = '';
        this.msaxios.setContext(context);
        let params = {'token': token};
        this.msaxios.getData('get_messages', params, function (err, response) {
            if (!err) {
                let rc = response.data.rc;
                if (rc=="ok") {
                    let messages = response.data.messages;
                    context.$log.info('Nachrichten empfangen.');
                    callback(false, messages);
                }
                else {
                    errormessage = response.data.message;
                }
            }
            else {
                errormessage = response;
            }
            if (errormessage.length) {
                context.$log.error('apiMessages msAxios Error: ' + errormessage);
                callback(true, errormessage);
            }
        });
    }
    //-----------------------------------------------------------------------
    logout(callback) {
        var self = this;
        this.loginCache.deleteCache(function () {
            self.loggedIn = false;                
            callback();
        });        
    }
    //-----------------------------------------------------------------------
    apiLogin(context, email, password, callback) {
        if (!this.isOnline())
            this.showError(context, 'Um sich anzumelden, müssen Sie sich mit dem Internet verbinden!');

        this.inProgress = true;
        var self = this;
        var errormessage = '';
        let params = {'email': email, 'password': password};
        this.msaxios.setContext(context);
        this.msaxios.getData("login", params, function (err, response){
            if (!err) {
                let rc = response.data.rc;
                if (rc=="ok") {
                    let token = response.data.token;
                    context.$log.info('Token: ' + token);
                    context.$log.info('Anmeldung erfolgreich!');
                    self.loggedIn = true;
                    self.saveCacheSetting({[MS_CONST.SETTING_VISITED]: 1});
                    self.saveCacheLogin(response.data, function() {
                        context.$router.push('/');    
                        callback(response.data.token);
                    });                    
                }
                else {
                    errormessage = response.data.message;
                }
            }
            else {
                errormessage = response;
            } 
            if (errormessage.length) {
                context.$log.error('apiLogin msAxios Error: ' + errormessage);
                context.$log.error('Anmeldung abgelehnt!');
                self.loggedIn = false;
                self.showError(context, 'Die Anmeldung ist fehlgeschlagen: ' + errormessage);
            }
            self.inProgress = false;
        });
    }
    //-----------------------------------------------------------------------
    apiCheckToken(context, token, callback) {
        context.$log.debug('apiCheckToken begin');
        if (!this.isOnline())
            {
            context.$log.info('User offline, Token-Check nicht möglich.');
            return true;
            }
        
        this.inProgress = true;
        var self = this;
        var errormessage = '';
        let params = {'token': token};
        this.msaxios.setContext(context);
        this.msaxios.getData("check_token", params, function (err, response){
            if (!err) {
                let rc = response.data.rc;
                if (rc=="ok") {
                    let token = response.data.token;
                    let messages = response.data.messages;                    
                    context.$log.info('Token: ' + token);
                    context.$log.info('Token-Check erfolgreich!');
                    self.saveCacheLogin(response.data);
                    self.loggedIn = true;
                    callback(messages);
                }
                else {
                    errormessage = response.data.message;
                }
            }
            else {
                errormessage = response;
            } 
            if (errormessage.length) {
                context.$log.error('apiCheckToken msAxios Error: ' + errormessage);
                context.$log.error('Token abgelehnt!');
                self.loggedIn = false;
                context.$router.push('/login');
                // todo: Lösche LoginCache
            }
            self.inProgress = false;
        });            
    }
    //-----------------------------------------------------------------------
    apiSubscribePush(context, token, subscription, callback) {
        context.$log.debug('apiSubscribePush begin');
        if (!this.isOnline())
            {
            context.$log.info('User offline, Push Subscription nicht möglich.');
            return false;
            }

        var self = this;
        var errormessage = '';
        let params = {'token': token, 'subscription': subscription};
        this.msaxios.setContext(context);

        this.msaxios.getData("subscribe_push", params, function (err, response){
            if (!err) {
                let rc = response.data.rc;
                if (rc=="ok") {
                    context.$log.info('Push Subscription erfolgreich beim Server registriert!');
                    self.saveCacheSetting({[MS_CONST.SETTING_SUBSCRIPTION]: subscription});
                    callback();
                }
                else {
                    errormessage = response.data.message;
                }
            }
            else {
                errormessage = response;
            } 
            if (errormessage.length) {
                context.$log.error('apiSubscribePush msAxios Error: ' + errormessage);
                context.$log.error('Push Subscription fehleschlagen!');
            }
        });                
    }
    //-----------------------------------------------------------------------
    // -ojb, 07.01.2020: Firebase wird nicht mehr verwendet
    apiSetFcmToken(context, token, testmode, callback) {
        context.$log.debug('apiSetFcmToken begin');
        if (!this.isOnline())
            {
            context.$log.info('User offline, FCM-Token-Registrierung nicht möglich.');
            return false;
            }

        var self = this;
        var errormessage = '';
        let params = {'token': token, 'testmode': testmode};
        this.msaxios.setContext(context);
    
        this.msaxios.getData("set_fcmtoken", params, function (err, response){
            if (!err) {
                let rc = response.data.rc;
                if (rc=="ok") {
                    if (testmode == 1) {
                        context.$log.info('FCM-Token im Testmodus erfolgreich beim Server registriert!');                        
                    }
                    else {
                        context.$log.info('FCM-Token erfolgreich beim Server registriert!');
                        self.saveCacheSetting({[MS_CONST.SETTING_FCMTOKEN]: token});
                        callback();
                    }
                }
                else {
                    errormessage = response.data.message;
                }
            }
            else {
                errormessage = response;
            } 
            if (errormessage.length) {
                context.$log.error('apiSetFcmToken msAxios Error: ' + errormessage);
                context.$log.error('FCM-Token nicht registriert!');
            }
        });            
    }
    //-----------------------------------------------------------------------
    apiAdrotateClick(context, adId, groupId, timerId, link) {
        context.$log.debug('apiAdrotateClick begin');
        if (!this.isOnline())
            {
            context.$log.info('User offline, AdRotate-Benachrichtigung nicht möglich.');
            return false;
            }
        var self = this;
        var errormessage = '';
       
        let params = {'ad': adId, 'group': groupId, 'timer': timerId};
        this.msaxios.setContext(context);

        this.msaxios.getData('adrotate_click', params, function (err, response){
            if (!err) {
                let rc = response.data.rc;
                if (rc=="ok") {
                    context.$log.info('AdRotate Click wurde ausgeführt');
                }
                else {
                    errormessage = response.data.message;
                }
            }
            else {
                errormessage = response;
            } 
            if (errormessage.length) {
                context.$log.error('apiAdrotateClick msAxios Error: ' + errormessage);
            }
        });            
        // An geklickten Link weiterleiten (und nicht auf Response warten)
        window.location.href = link;
    }
}
//-----------------------------------------------------------------------
export default {
    install (Vue, options) {  
        Vue.prototype.$ms = new msCore();
    }
}